export default __webpack_public_path__ + "static/media/Procurement.e29b6f76.png";